module.exports = __webpack_public_path__ + "static/media/movefile.2e8d7cd2.svg";